var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSun(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 19.3332C16.9455 19.3332 19.3334 16.9454 19.3334 13.9998C19.3334 11.0543 16.9455 8.6665 14 8.6665C11.0545 8.6665 8.66669 11.0543 8.66669 13.9998C8.66669 16.9454 11.0545 19.3332 14 19.3332Z",
    stroke: "currentColor",
    strokeWidth: 2.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6667 14H26M2 14H3.33333M14 24.6667V26M14 2V3.33333M21.5427 21.5427L22.4853 22.4853M5.51467 5.51467L6.45733 6.45733M6.45733 21.5427L5.51467 22.4853M22.4853 5.51467L21.5427 6.45733",
    stroke: "currentColor",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSun);
export default __webpack_public_path__ + "static/media/sun.817aa9a04249d205395d6428f1a2f8a5.svg";
export { ForwardRef as ReactComponent };